import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";

// css
import "./Authcss.scss";

// img
import authImg from "../../Assets/images/auth.png";
import logo from "../../Assets/images/logo.png";

const AuthLayout = () => {
  return (
    <>
      <section
        className="authLayout position-relative py-md-5 py-3 d-flex align-items-center justify-content-center flex-column"
        style={{ zIndex: "9" }}
      >
        <Container className="">
          <Row className="justify-content-between align-items-center">
            <Col lg="6" className="my-2 imgWrpper text-center d-lg-block d-none">
              <img src={authImg} alt="" className="img-fluid" />
            </Col>
            <Col lg="5" className="my-2 formWrpper">
              <div className="bg-white inner p-lg-0 px-sm-5 py-3 px-3">
                <div className="logo text-center">
                  <img src={logo} alt="" className="img-fluid" />
                </div>
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AuthLayout;
